import { withInstall } from "../utils/index.mjs";
import _Rate from "./Rate.mjs";
const Rate = withInstall(_Rate);
var stdin_default = Rate;
import { rateProps } from "./Rate.mjs";
export {
  Rate,
  stdin_default as default,
  rateProps
};
